import { useEffect, useState } from "react";

export const ROTATION_KEY = "vyoo.monitoring.rotation.v1";
export const validSeconds = (value) => Number.isInteger(Number(value)) && Number(value) >= 5 && Number(value) <= 3600;
export function readRotation() {
  try {
    const saved = JSON.parse(localStorage.getItem(ROTATION_KEY));
    return { enabled: saved?.enabled === true, seconds: validSeconds(saved?.seconds) ? Number(saved.seconds) : 30 };
  } catch { return { enabled: false, seconds: 30 }; }
}

export default function useMonitoringTabs(paused) {
  const [tab, setTab] = useState("servers");
  const [rotation, setRotation] = useState(readRotation);
  const [visible, setVisible] = useState(!document.hidden);
  useEffect(() => {
    try { localStorage.setItem(ROTATION_KEY, JSON.stringify(rotation)); } catch { /* Armazenamento indisponível: mantém a preferência nesta sessão. */ }
  }, [rotation]);
  useEffect(() => {
    const visibility = () => setVisible(!document.hidden);
    document.addEventListener("visibilitychange", visibility);
    return () => {
      document.removeEventListener("visibilitychange", visibility);
    };
  }, []);
  useEffect(() => {
    if (!rotation.enabled || paused || !visible) return undefined;
    const timer = setInterval(() => {
      // Um controle removido do DOM pode perder o foco sem emitir blur/focusout.
      // Consulta o foco atual para não deixar a alternância presa em pausa.
      const editing = document.activeElement?.closest("input,select,textarea,[contenteditable='true'],[data-pause-rotation]");
      // Modais de confirmação também suspendem a troca, mesmo quando externos ao React.
      const dialog = document.querySelector("[role='dialog'],[aria-modal='true'],[data-rotation-settings]");
      if (!editing && !dialog) {
        setTab(current => current === "servers" ? "cloud" : "servers");
      }
    }, rotation.seconds * 1000);
    return () => clearInterval(timer);
  }, [tab, rotation, paused, visible]);
  return { tab, setTab, rotation, setRotation };
}
